import { render, staticRenderFns } from "./UsersPage.vue?vue&type=template&id=21b791ae&scoped=true&"
import script from "./UsersPage.vue?vue&type=script&lang=js&"
export * from "./UsersPage.vue?vue&type=script&lang=js&"
import style0 from "./UsersPage.vue?vue&type=style&index=0&id=21b791ae&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b791ae",
  null
  
)

export default component.exports